import React from "react"

const Badge: React.FC<{ label: string; tone?: "success" | "warning" }> = ({ label, tone = "success" }) => {
  const styles = tone === "success" ? "tw-bg-emerald-100 tw-text-emerald-700" : "tw-bg-amber-100 tw-text-amber-700"
  return (
    <span
      className={`tw-inline-flex tw-items-center tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium ${styles}`}>
      {label}
    </span>
  )
}

export default Badge
